
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Inventory, InventoryUiClient } from '../../../../backend/backendapi';
import { initClient } from '../../../../../api';
import TabAttachments from './TabAttachments';
import TabGeneral from './TabGeneral';
import TabInventoryBins from './TabInventoryBins';
import TabMisc from './TabMisc';
import TabButton from '../../../../util/TabButton';
import TabInventoryContacts from './TabInventoryContacts';

@Component({
  name: 'InventoryEditModal',
  components: {
    TabAttachments,
    TabButton,
    TabGeneral,
    TabInventoryBins,
    TabInventoryContacts,
    TabMisc,
  },
})
export default class InventoryEditModal extends Vue {
  inventory: Inventory | null = null;
  edit: boolean = false;
  tab: 'general' | 'attachments' | 'misc' | 'bins' = 'general';

  //api
  private readonly service = initClient(InventoryUiClient);

  public open(inventory: Inventory, edit: boolean): void {
    this.inventory = inventory;
    this.edit = edit;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  private postSetting(): void {
    if (!this.inventory) {
      return;
    }

    let savePromise: Promise<void>;
    if (!this.edit) {
      savePromise = this.service.postData(this.inventory);
    } else {
      savePromise = this.service.updateData(this.inventory);
    }

    savePromise
        .then(_ => {
          this.$toasted.info(this.$t('txtSaved').toString());
          this.$emit('saved');
          this.dismiss();
          this.edit = false;
        })
        .catch(e => this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e)));
  }
}
